var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPortateis = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: "new 0 0 40 40"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M39.9,33.3c0-0.3-0.2-0.6-0.5-1c-0.3-0.4-0.9-1.5-2-3.1c-1.1-1.7-1.7-2.5-1.7-2.5V6.8c0-1.2-0.4-2.2-1.3-3 c-0.9-0.8-1.9-1.3-3-1.3H8.6c-1.2,0-2.2,0.4-3,1.3c-0.9,0.8-1.3,1.8-1.3,3v19.9c0,0-0.6,0.8-1.7,2.5c-1.1,1.7-1.8,2.7-2,3.1 c-0.3,0.4-0.4,0.7-0.5,1C0,33.6,0,33.9,0,34.2v1.1c0,0.5,0.2,1,0.7,1.5c0.4,0.4,0.9,0.7,1.5,0.7h35.7c0.5,0,1-0.2,1.5-0.7 c0.4-0.4,0.7-0.9,0.7-1.5v-1.1C40,33.9,40,33.6,39.9,33.3z M13.6,33.1l1.3-2.8h10.3l1.3,2.8H13.6z M30.8,23.3c0,0.7-0.6,1.3-1.3,1.3 H10.5c-0.7,0-1.3-0.6-1.3-1.3V8.7c0-0.7,0.6-1.3,1.3-1.3h19.1c0.7,0,1.3,0.6,1.3,1.3V23.3z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPortateis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_portateis.4d9dc156.svg";
export { ForwardRef as ReactComponent };